import { render, staticRenderFns } from "./carDelivery.vue?vue&type=template&id=b99cdf78&scoped=true&"
import script from "./carDelivery.vue?vue&type=script&lang=js&"
export * from "./carDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99cdf78",
  null
  
)

export default component.exports